import React from "react";
import './TicketMainCard.css'

const TicketMainCard = ({ ticket }) => (
    <div className="ticket-main-card">
      <div className="ticket--header">
        <h1 className="ticket-title">{ticket.title}</h1>
        <div
          className="ticket-status"
          style={{
            backgroundColor: 
              ticket.status === "Opened" ? "black" :
              ticket.status === "Pending" ? "blue" :
              ticket.status === "Resolved" ? "green" :
              ticket.status === "Closed" ? "red" :
              "transparent"
          }}
        >
          {ticket.status}
        </div>
      </div>
      
      <div className="ticket-client-info">
        <p className="client-name">
          Client: <em><span>{ticket.client.username}</span></em>, 
          Client ID: <em><span>{ticket.client.id}</span></em>
        </p>
        <p>Email: <em><span>{ticket.client.email}</span></em></p>
      </div>
      
      <div className="ticket-description">
        <h3>Description</h3>
        <p>{ticket.description}</p>
      </div>
  
      <div className="ticket-assignment">
        <p>
          Opened By: 
          {ticket.createdBy?.username 
            ? `Agent ${ticket.createdBy.username}` 
            : `Client ${ticket.client.username}`}
        </p>
        <p>Assigned To: {ticket.assignedTo?.username || 'Unassigned'}</p>
      </div>
      
      <div className="ticket-metadata">
        <div className="metadata-item">
          <strong>Status:</strong> {ticket.status}
        </div>
        <div className="metadata-item">
          <strong>Category:</strong> {ticket.category}
        </div>
        <div className="metadata-item">
          <strong>Subcategory:</strong> {ticket.subcategory}
        </div>
      </div>
    </div>
  );

export default TicketMainCard;